import { render, staticRenderFns } from "./CardDashboardBonificacao.vue?vue&type=template&id=6ce49c59"
import script from "./CardDashboardBonificacao.vue?vue&type=script&lang=js"
export * from "./CardDashboardBonificacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports